import React, { Fragment } from "react";

/* mui */
import Typography from "@material-ui/core/Typography";
/* mui */

/* packages */
import { ModuleWrapperInfo } from "../../util-atomic-design";
/* packages */

const index = ({ productId, productName, path }) => {
  return (
    <Fragment>
      <div className="pb-10 mb-3">
        <Typography variant="h6">
          <img width="20%" src={path} /> &nbsp;
          <b>
            <small className="">{productName}</small>
          </b>
        </Typography>
      </div>
    </Fragment>
  );
};

export default index;
